import { useContext, useEffect } from "react";

import { useAuth0 } from "@auth0/auth0-react";

import { setLogout, setToken } from "utils/auth";

import { AuthTokenContext } from "components/AuthProvider/AuthProviderContext";

export default function Auth0LogoutInitializer() {
  const { logout } = useAuth0();

  useEffect(() => {
    setLogout(() =>
      logout({
        logoutParams: {
          returnTo: window.location.origin,
        },
      }),
    );
  }, [logout]);

  const token = useContext(AuthTokenContext);

  useEffect(() => {
    setToken(token);
  }, [token]);

  return null;
}
